export enum SocketErrorType {
	MissingData,
	IncorrectData,
	NotAuthorized,
}

export type SocketError = {
	code: SocketErrorType
	message: string
}
